import React, { useEffect, useState } from "react";
import { IoIosArrowDropright, IoMdCloseCircleOutline } from "react-icons/io";
import { CgInfo } from "react-icons/cg";
import {
  AiOutlineCheck,
  AiOutlineClose,
  AiOutlineCloseCircle,
  AiOutlineInfoCircle,
} from "react-icons/ai";
import { useStores } from "../../store";
import { MdInfo } from "react-icons/md";
import Tooltip from "./tooltip";
import { use } from "react";
import { toJS } from "mobx";
import { PiWarningCircleLight } from "react-icons/pi";
import Popup from "./popup";
import MailPopup from "./mailPopup";

const ProgressBar = ({
  steps = [
    { label: "Basic Info", completed: true, label2: "Step 1", show: true },
    { label: "Skills", completed: true, label2: "Step 2", show: true },
    { label: "Previous Work", completed: true, label2: "Step 3", show: true },
    { label: "Resume", completed: false, label2: "Step 4", show: true },
  ],
  percentage = 0,
  buttonName = "Complete Profile",
  buttonAction = () => {
    alert("Complete Profile button clicked!");
  },
  description = "Complete your company profile to unlock full functionality and enhance your hiring potential.",
  closeIcon = (
    <AiOutlineClose className="text-white text-md p-1 rounded-full cursor-pointer bg-primary" />
  ),
  onClose,
}) => {
  const normalizedRadius = 38 - 4 / 2;
  const circumference = 2 * Math.PI * normalizedRadius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <div className="bg-[#151515] md:p-2 md:pb-10 rounded-xl flex flex-col md:flex-row justify-start items-center md:m-0 mx-0 relative">
      <div
        className="absolute rounded-full w-6 h-6 flex items-center justify-center bg-primary -top-2 -right-2 cursor-pointer "
        onClick={onClose}
      >
        {closeIcon}
      </div>
      <div className="flex flex-row items-center ml-2  w-full  md:w-auto ">
        <div className="relative w-20 h-20   md:mt-0 -my-7 ml-5">
          <svg className="w-[80px] h-[80px] transform -rotate-90 -ml-5 md:ml-2 ">
            <circle cx="38" cy="38" r="34" stroke="#3E3E3E" fill="#3E3E3E" />
            <circle
              cx="38"
              cy="38"
              r="34"
              stroke="currentColor"
              strokeWidth="4"
              fill="transparent"
              className="text-orange-500"
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
            />
          </svg>
          <span className="absolute inset-0 flex h-full items-center  justify-center text-white text-lg  md:-mb-1  mt-[2px] mb-0 md:ml-4 -ml-9">
            {percentage}%
          </span>
        </div>
        <div className="flex-1 md:ml-8">
          <div className="flex md:w-full w-64 justify-between md:items-center items-end mb-2">
            <p className="text-white text-sm md:text-base md:font-medium ml-3 md:ml-0 md:mt-0 mt-3">
              {description}
            </p>
          </div>
          <ProgressBarTracker steps={steps} commingFrom={"companySide"} />
        </div>
      </div>
      <div className="w-auto flex justify-start items-start md:w-auto my-5 md:ml-auto">
        <button
          className="flex items-center px-4 py-2 bg-orange-500 text-white rounded-lg w-full md:w-auto mt-9 md:mr-5 lg:mr-5 ml-7"
          onClick={buttonAction}
        >
          {buttonName}
          <IoIosArrowDropright className="ml-2" />
        </button>
      </div>
    </div>
  );
};

export default ProgressBar;

export const ProgressBarTracker = ({
  steps,
  commingFrom,
  onRejectClickWhy,
  width = "w-full md:w-full",
  reject = false,
}) => {
  const [popup, setPopup] = useState(false);
  const [popupContent, setPopupContent] = useState("");
  const [popupSubject, setPopupSubject] = useState("");
  const [popupPurpose, setPopupPurpose] = useState("");
  const [popupDate, setPopupDate] = useState("");
  const { PopupStore } = useStores();

  const handleStepClick = (step) => {
    if (step.popup) {
      setPopup(true);
      setPopupSubject(step.subject || "");
      setPopupContent(step.body || "");
      setPopupPurpose(step.purpose || "");
      setPopupDate(step.date || "");
    }
  };

  return (
    <>
      <div
        className={`flex items-center ${width} md:mt-0 mt-4 -mb-3 md:mb-0 px-4`}
      >
        {steps
          ?.filter((step) => step.show)
          .sort((a, b) => {
            // First sort by whether items have dates
            if (a.date && !b.date) return -1;
            if (!a.date && b.date) return 1;

            // If both have dates, sort by date
            if (a.date && b.date) {
              return new Date(a.date) - new Date(b.date);
            }

            // For items without dates, completed items come first
            if (!a.date && !b.date) {
              if (a.completed && !b.completed) return -1;
              if (!a.completed && b.completed) return 1;
              // Keep original order for remaining items
              return 0;
            }

            return 0;
          })
          .map((step, index, filteredSteps) => (
            <React.Fragment key={index}>
              {index > 0 && (
                <div
                  className={`flex-1 h-0.5 ${step.label2 === "Technical Interview" ? "pr-5" : ""} ${
                    step.warning
                      ? "bg-yellow"
                      : filteredSteps[index].rejected ||
                        filteredSteps[index].reject
                      ? "bg-red-500"
                      : step.completed
                      ? "bg-green-500"
                      : step.label === "ShortListed"
                      ? "bg-yellow"
                      : step.proxy
                      ? "bg-yellow"
                      : "bg-gray-300"
                  }`}
                ></div>
              )}
              <Tooltip
                id={`Application${index}`}
                position="bottom"
                content={
                  step.toolTip ? (
                    <p>{step.toolTip}</p>
                  ) : (
                    <p>
                      {!step.show
                        ? "Assesment not added"
                        : step?.reject
                        ? "Status: Rejected"
                        : step?.proxy
                        ? "Status: Proxy"
                        : step?.completed
                        ? "Status: Completed"
                        : "Status: Pending"}{" "}
                      {step?.completed && step?.date && (
                        <span>
                          {" "}
                          <br /> on :{step?.date}
                        </span>
                      )}{" "}
                      {step?.reson && step?.reson !== "" && (
                        <span>
                          <br /> Reason: {step?.reson}{" "}
                        </span>
                      )}
                    </p>
                  )
                }
              >
                <div
                  className={`relative flex flex-col items-center  ${
                    step.popup ? "cursor-pointer" : ""
                  }`}
                  onClick={() => handleStepClick(step)}
                >
                  <div
                    className={`relative w-8 h-8 rounded-full ${
                      step.warning
                        ? "bg-yellow"
                        : step.rejected || step.reject || step.label === "Rejected"
                        ? "bg-red-500"
                        : step.proxy || step.label === "Proxy"
                        ? "bg-yellow"
                        : step.label === "ShortListed"
                        ? "bg-yellow"
                        : step.completed
                        ? "bg-green-500"
                        : commingFrom === "companySide"
                        ? "bg-white"
                        : step.show === false
                        ? "bg-gray-300"
                        : step.reject === true
                        ? "bg-red-500"
                        : "bg-gray-300"
                    } flex items-center justify-center`}
                  >
                    <span
                      className={`text-xs ${
                        step.rejected
                          ? "text-white"
                          : step.completed
                          ? "text-white"
                          : commingFrom === "companySide"
                          ? "text-gray-400"
                          : step.label === "ShortListed"
                          ? "text-white"
                          : step.proxy
                          ? "text-white"
                          : step.reject === true
                          ? "text-white"
                          : "text-gray-400"
                      }`}
                    >
                      {!step.show ? (
                        <MdInfo className="text-yellow bg-white rounded-full object-cover text-4xl" />
                      ) : step.warning ? (
                        <PiWarningCircleLight className="text-xl" />
                      ) : step.rejected ? (
                        <IoMdCloseCircleOutline className="text-xl" />
                      ) : step.reject ? (
                        <IoMdCloseCircleOutline className="text-xl" />
                      ) : step.proxy ? (
                        <IoMdCloseCircleOutline className="text-xl" />
                      ) : step.completed ? (
                        <AiOutlineCheck />
                      ) : (
                        <AiOutlineCheck />
                      )}
                    </span>
                  </div>
                  <div
                    className={`absolute text-[10px] md:text-sm ${
                      commingFrom === "companySide" ? "mt-14" : "mt-8"
                    } flex flex-col justify-center items-start ${
                      commingFrom === "companySide" ? "-left-2" : "left-0"
                    }  ${
                      window.innerWidth > 768 ? "md:left-0.5" : "left-0"
                    } min-w-max  ${
                      commingFrom === "companySide" && "text-white -top-4 "
                    }`}
                  >
                    {window.innerWidth > 768 ? (
                      step.label === "Rejected" && step.rejected === true ? (
                        <div className="text-center">
                          <p className="text-xs">Rejected</p>
                          <p
                            className="text-xs hover:underline cursor-pointer"
                            onClick={() => onRejectClickWhy()}
                          >
                            Why ?
                          </p>
                        </div>
                      ) : (
                        <div className="text-center">
                          <p className="text-xs">{step.label}</p>
                          {step.sub && (
                            <p className="text-xs opacity-70">{step.sub}</p>
                          )}
                        </div>
                      )
                    ) : step.label2 === "Rejected" ? (
                      <div className="text-center">
                        <p className="text-xs">Rejected</p>
                        <p
                          className="text-xs hover:underline cursor-pointer"
                          onClick={() => PopupStore.setInterviewDetails(true)}
                        >
                          Why ?
                        </p>
                      </div>
                    ) : (
                      <div className="text-center">
                        <p className="text-xs">
                          {step.label2}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </Tooltip>
            </React.Fragment>
          ))}
      </div>

      <MailPopup
        isOpen={popup}
        onClose={() => setPopup(false)}
        subject={popupSubject}
        body={popupContent}
        purpose={popupPurpose}
        date={popupDate}
      />
    </>
  );
};
